import { RouteComponentProps } from '@reach/router'
import { Box } from 'reoil'
import Navigation from '../components/Navigation'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { useThemeValue } from '../store/themeState'
import { rgba } from 'polished'
import BtnBottom from '../components/BtnBottom'
import { responseBoxProp } from '../utils/propsHelpers'
import { useJobsValue } from '../store/jobsState'
import useFetchJobs from '../hooks/api/useFetchJobs'
import fetcher from '../utils/fetcher'
import { ResponseData } from '../hooks/api/types'
import { toast } from 'react-toastify'
import goto from '../utils/goto'
import TabNav from '../components/TabNav'

interface JobsDetailPageProps extends RouteComponentProps {
  id?: string
}

const JobsDetailPage: React.FC<JobsDetailPageProps> = ({id}) => {
  // 全局状态
  const theme =  useThemeValue()
  const jobs = useJobsValue()

  // 获取数据
  useFetchJobs()

  // 当前job数据
  const currentJob = jobs.find(item=>item.id === id)

  const chipColor1 = rgba(theme.colors.primary, .2)
  const chipColor2 = rgba(theme.colors.secondary, .2)

  // 点击立即投递
  const handleClickDeliver = async ()=>{
    const res:ResponseData<unknown> = await fetcher.get(`/content.php?a=SaveDelivery&jobsid=${id}`)

    if(!res.success && res.errorCode === 405) { // 没有简历 去创建
      goto('/user/resume/create', {state: {fromJob: true}})
    }
    if(res.success) {
      toast(res.message, {type: 'success'})
    }
  }

  return(
    <Box className='JobsDetailPage' stretch pb={6}>
      <TabNav />
      <Navigation title='岗位详情' bg='white' />

      <Box className="title" bg='white' p={3} py={4}>
        <Box {...responseBoxProp} lineHeight={1.5}>
          <h2>{currentJob?.title}</h2>
          <h4 style={{opacity: .6, fontWeight: 400}}>{currentJob?.company}</h4>
          <Box row flexWrap='wrap' mt={2}>
            {currentJob?.posts.map((post, i)=>(
              <Box key={i} className="chip" fontSize={0} bg={chipColor1} color='primary' px={2} py={1} borderRadius={0} mt={2} mr={2}>{post}</Box>
            ))}
            {currentJob?.locations.map((location, i)=>(
              <Box key={i} className="chip" fontSize={0} bg={chipColor2} color='secondary' px={2} py={1} borderRadius={0} mt={2} mr={2}>{location.name}</Box>
            ))}
          </Box>
        </Box>
      </Box>

      <Box className="detail" bg='white' p={3} py={4} mt={2} css={css`
        p {
          color: ${theme.colors.text.body2};
          margin-bottom: 24px;
          line-height: 1.4;
        }
      `}>
        <Box {...responseBoxProp}>
          <h4>招聘人数</h4>
          <p>{currentJob?.recruit_count}人</p>

          <h4>岗位要求</h4>
          <p dangerouslySetInnerHTML={{__html: currentJob?.requirement || ''}} />

          <h4>岗位职责</h4>
          <p dangerouslySetInnerHTML={{__html: currentJob?.duty || ''}} />

          <h4>工作地点</h4>
          <p>{currentJob?.locations.map(loc=>loc.name).join('、')}</p>
        </Box>
      </Box>

      <BtnBottom onClick={handleClickDeliver} disabled={currentJob?.delivered}>{currentJob?.delivered ? '您已投递该职位'  : '立即投递'}</BtnBottom>

    </Box>
  )
}

export default JobsDetailPage
